document.addEventListener('DOMContentLoaded', () => {
  // Fade-in observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.1 });
  document.querySelectorAll('.vamex-fade').forEach(el => observer.observe(el));

  // Mobile menu toggle (Dawn uses native menu, this is fallback)
  const mobileBtn = document.querySelector('.vamex-mobile-toggle');
  const mobileNav = document.querySelector('.vamex-mobile-nav');
  if(mobileBtn) {
    mobileBtn.addEventListener('click', () => {
      mobileNav.style.display = mobileNav.style.display === 'flex' ? 'none' : 'flex';
    });
  }
});
